import type CreatorGroupLabel from '@/types/creatorGroupLabel';
import creatorGroupsFetchers from '@/api/fetchers/creatorGroups';
import useDataQuery from '@/hooks/use-data-query';

type UseCreatorGroupsLabelsQueryParams = {
  creatorGroupId?: string;
  refetchOnWindowFocus?: boolean;
  enabled?: boolean;
};

function useCreatorGroupsLabelsQuery({
  creatorGroupId,
  refetchOnWindowFocus = true,
  enabled = true,
}: UseCreatorGroupsLabelsQueryParams) {
  const response = useDataQuery({
    queryKey: ['creatorGroupsLabels', creatorGroupId],
    queryFn: creatorGroupsFetchers.labels,
    enabled: enabled && !!creatorGroupId,
    meta: {creatorGroupId},
    refetchOnWindowFocus,
  });

  return {
    ...response,
    labels: (response.data || []) as CreatorGroupLabel[],
  };
}

export default useCreatorGroupsLabelsQuery;
